import { render, staticRenderFns } from "./IntegralGoodsDetails.vue?vue&type=template&id=1c4336d0&scoped=true"
import script from "./IntegralGoodsDetails.vue?vue&type=script&lang=js"
export * from "./IntegralGoodsDetails.vue?vue&type=script&lang=js"
import style0 from "./IntegralGoodsDetails.vue?vue&type=style&index=0&id=1c4336d0&prod&lang=scss&scoped=true"
import style1 from "./IntegralGoodsDetails.vue?vue&type=style&index=1&id=1c4336d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4336d0",
  null
  
)

export default component.exports